export default __webpack_public_path__ + "static/0008-1aa98ee4f60157067d744748bdb3bb30.png";